import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => [
  { title: "Support – TagFlow" },
];

export default function Support() {
  return (
    <div style={{ maxWidth: 760, margin: "60px auto", padding: "0 24px", fontFamily: "system-ui, sans-serif", lineHeight: 1.7, color: "#333" }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>TagFlow Support</h1>
      <p style={{ color: "#666", marginBottom: 32 }}>We're here to help.</p>

      <h2>Getting Started</h2>
      <p>
        TagFlow automatically tags your Shopify orders based on IF/THEN rules you define.
        From the app dashboard, click <strong>+ New Rule</strong> to create your first rule.
      </p>

      <h2>Common Questions</h2>

      <h3>When do rules run?</h3>
      <p>
        Rules are evaluated automatically whenever an order is created (<code>orders/create</code>)
        or updated (<code>orders/updated</code>) in your store.
      </p>

      <h3>Can I have multiple conditions?</h3>
      <p>
        Yes. A rule can have multiple conditions — <strong>all conditions must match</strong> for
        the tag to be applied (AND logic).
      </p>

      <h3>Can I use the same tag in multiple rules?</h3>
      <p>
        Yes. Multiple rules can apply the same or different tags. All matching rules are applied
        to each order.
      </p>

      <h3>How do I disable a rule without deleting it?</h3>
      <p>
        Use the toggle on each rule card in the dashboard to enable or disable it instantly.
      </p>

      <h2>Contact Us</h2>
      <p>
        For questions, feature requests, or bug reports, email us at:{" "}
        <a href="mailto:support@tagflow.app">support@tagflow.app</a>
      </p>
      <p>We aim to respond within 24 hours on business days.</p>

      <hr style={{ margin: "40px 0", borderColor: "#eee" }} />
      <p style={{ color: "#999", fontSize: 14 }}>
        <a href="/privacy">Privacy Policy</a>
      </p>
    </div>
  );
}
